<main>
  <app-loading *ngIf="showLoading"></app-loading>
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
  <span class="version">v {{ VERSION }}</span>
</main>
